// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 18:30:36

export default {
  "id": "warfare-1942-online-shooter",
  "slug": "warfare-1942-online-shooter",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/8cc62e5427cf443dab15634e5dfe7937-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/8cc62e5427cf443dab15634e5dfe7937/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Warfare 1942 - online shooter",
      "description": "Immerse yourself in the atmosphere of World War II, where every battle is a unique fight for survival!\nThe game is designed for military enthusiasts and those who love intense online battles. It’s the perfect choice for players who prefer shooters with detailed gameplay, a variety of characters, and customization. Suitable for both seasoned fighters and newcomers.",
      "instructions": "In the game, you can connect with other players and participate in session-based battles. The winner is the one who scores the most points by the end of the match!\n\nControls for keyboard and mouse:\nTAB - pause menu\nWASD - movement\nSPACE - jump\nC - crouch\nM - open map\n1 - 5 - select item\nLMB - shoot\nRMB - aim\nR - reload\nU - use dog ability\nT - type in chat",
      "genres": [
        "Battle",
        "Shooter"
      ],
      "tags": [
        "3d",
        "pet",
        "tank",
        "war",
        "weapons"
      ]
    },
    "zh-CN": {
      "title": "《1942战争》- 在线射击游戏",
      "description": "沉浸于二战的氛围中，每一场战斗都是一场独特的生存之战！\n这款游戏专为军事爱好者以及热爱激烈在线战斗的玩家设计。是那些偏爱细致游戏玩法、多样化角色和可定制的射击游戏玩家的完美选择。适合经验丰富的战斗者和新手。",
      "instructions": "在游戏中，你可以与其他玩家连接并参与基于会话的战斗。比赛结束时得分最高的人获胜！\n\n键盘和鼠标操作说明：\nTAB - 暂停菜单\nWASD - 移动\nSPACE - 跳跃\nC - 蹲下\nM - 打开地图\n1 - 5 - 选择物品\nLMB - 射击\nRMB - 瞄准\nR - 重新装填\nU - 使用狗的能力\nT - 在聊天中输入",
      "genres": [
        "战斗",
        "射击"
      ],
      "tags": [
        "三维",
        "宠物",
        "坦克",
        "战争",
        "武器"
      ]
    },
    "zh-TW": {
      "title": "戰爭1942 - 在線射擊遊戲",
      "description": "沉浸在二戰的氛圍中，每場戰鬥都是為生存而獨立奮戰！這款遊戲設計給軍事愛好者以及喜愛激烈網絡戰鬥的玩家。它是那些偏好細節豐富遊戲玩法、多元角色和自定義的射手玩家的完美選擇。適合有經驗的戰士和新手玩家。",
      "instructions": "在遊戲中，您可以與其他玩家聯繫並參與會話基礎戰鬥。比賽結束時得分最高者為勝利者！\n\n鍵盤和滑鼠操作：\nTAB - 暫停選單\nWASD - 移動\nSPACE - 跳躍\nC - 蹲下\nM - 開啟地圖\n1 - 5 - 選擇物品\nLMB - 射擊\nRMB - 調整擊準\nR - 裝填彈藥\nU - 使用狗的能力\nT - 在聊天中輸入",
      "genres": [
        "戰鬥",
        "射擊"
      ],
      "tags": [
        "3D",
        "寵物",
        "坦克",
        "戰爭",
        "武器"
      ]
    },
    "zh-HK": {
      "title": "戰爭1942 - 在線射擊遊戲",
      "description": "投身於第二次世界大戰的氣氛之中，每場戰鬥都是為生存而展開的獨特戰鬥！遊戲設計給軍事愛好者和喜歡激烈網絡戰鬥的人士。這是喜歡細節豐富的射擊遊戲、多種角色和自定義功能的玩家的完美選擇。適合經驗豐富的戰士和新手。",
      "instructions": "在遊戲中，您可以連接其他玩家並參與基於場次的戰鬥。比賽結束時得分最高的玩家為勝利者！\n\n鍵盤和滑鼠操作：\nTAB - 暫停選單\nWASD - 移動\nSPACE - 跳躍\nC - 蹲下\nM - 開啟地圖\n1 - 5 - 選擇物品\nLMB - 射擊\nRMB - 調整目標\nR - 製彈\nU - 使用犬隻能力\nT - 聊天輸入",
      "genres": [
        "戰鬥",
        "射擊"
      ],
      "tags": [
        "3D",
        "寵物",
        "戰車",
        "戰爭",
        "武器"
      ]
    },
    "ja": {
      "title": "ウォーフェア1942 - オンラインシューティングゲーム",
      "description": "第二次世界大戦の雰囲気に没頭し、それぞれの戦闘が生き延びるためのユニークな戦いとなる！このゲームは軍事ファンや激しいオンラインバトルを好む人々にデザインされており、詳細なゲームプレイ、多様なキャラクター、カスタマイズが可能なシューティングゲームが好むプレイヤーに最適です。ベテランの戦士も新参者も対応しています。",
      "instructions": "ゲーム内で、他のプレイヤーとつながり、セッションベースの戦闘に参加できます。勝利は、試合終了時点での得点が最も高いプレイヤーです！\n\nキーボードとマウスの操作：\nTAB - ポーズメニュー\nWASD - 移動\nSPACE - 跳躍\nC - 伏せる\nM - 地図を開く\n1 - 5 - アイテムを選択\nLMB - 射撃\nRMB - 瞄準\nR - リロード\nU - 犬の能力を使用\nT - チャットにテキスト入力",
      "genres": [
        "バトル",
        "シューティング"
      ],
      "tags": [
        "3D",
        "ペット",
        "戦車",
        "戦争",
        "武器"
      ]
    },
    "ko": {
      "title": "전쟁 1942 - 온라인 쏘거트",
      "description": "제2차 세계대전의 분위기에 몰입해 보세요. 여기서는 모든 전투가 독특한 생존의 전투입니다!\n이 게임은 군사 애호가와 강력한 온라인 전투를 사랑하는 사람들을 위해 설계되었습니다. 자세한 게임 플레이, 다양한 캐릭터, 맞춤화된 옵션을 선호하는 플레이어들에게 완벽한 선택입니다. 경험 많은 전투자이자 신입자들에게도 적합합니다.",
      "instructions": "게임에서 다른 플레이어와 연결하여 세션 기반 전투에 참여할 수 있습니다. 경기가 끝나면 가장 많은 점수를 얻은 사람이 승자입니다!\n\n키보드와 마우스 조작법:\nTAB - 일시정지 메뉴\nWASD - 이동\nSPACE - 점프\nC - 숨기기\nM - 지도 열기\n1 - 5 - 아이템 선택\nLMB - 발사\nRMB - 정확도 조절\nR - 재장전\nU - 개의 능력 사용\nT - 채팅 입력",
      "genres": [
        "전투",
        "쏜사격"
      ],
      "tags": [
        "3D",
        "반려동물",
        "탱크",
        "전쟁",
        "무기"
      ]
    },
    "fr": {
      "title": "Guerre 1942 - tireur en ligne",
      "description": "Immergez-vous dans l'atmosphère de la Seconde Guerre mondiale, où chaque bataille est un combat unique pour la survie !\nLe jeu est conçu pour les passionnés militaires et ceux qui aiment les combats en ligne intenses. C'est le choix parfait pour les joueurs qui préfèrent les tireurs avec un gameplay détaillé, une variété de personnages et des personnalisations. Idéal pour les combattants chevronnés et les débutants.",
      "instructions": "Dans le jeu, vous pouvez vous connecter avec d'autres joueurs et participer à des batailles basées sur des sessions. Le gagnant est celui qui a le plus de points à la fin du match !\n\nCommandes pour le clavier et la souris :\nTAB - menu de pause\nWASD - déplacement\nESPACE - saut\nC - se pencher\nM - ouvrir la carte\n1 - 5 - sélectionner un objet\nCMB GAUCHE - tirer\nCMB DROITE - viser\nR - recharger\nU - utiliser l'aptitude du chien\nT - écrire dans le chat",
      "genres": [
        "Bataille",
        "Tir à vue"
      ],
      "tags": [
        "3D",
        "animal de compagnie",
        "char",
        "guerre",
        "armes"
      ]
    }
  }
};
